import React, { useState } from 'react';
import { Box, Card, CardContent, Typography } from '@mui/material';
import EnablementSection from './EnablementSection';
import { CardData, EditType, NormalizedAgentData } from '../types';

interface AiEnablementViewProps {
  normalizedAgentData: NormalizedAgentData;
  isLoading: boolean;
  isEditing: boolean;
  onEdit: (type: EditType, item?: any) => void;
}

const SECTION_CONFIG = [
  {
    key: 'embedded' as const,
    label: 'Embedded',
    iconSrc: '/images/Embedded_icon1.svg',
    bgcolor: '#F6F1FF',
    skeletonBgcolor: '#FFF7F3',
    skeletonCount: 3,
  },
  {
    key: 'extended' as const,
    label: 'Extended',
    iconSrc: '/images/extended_icon.svg',
    bgcolor: '#FFFBED',
    skeletonBgcolor: '#FFFBED',
    skeletonCount: 2,
  },
  {
    key: 'custom' as const,
    label: 'Custom',
    iconSrc: '/images/client_specific.svg',
    bgcolor: '#F4FFF2',
    skeletonBgcolor: '#F4FFF2',
    skeletonCount: 1,
  },
];

const AiEnablementView: React.FC<AiEnablementViewProps> = ({
  normalizedAgentData,
  isLoading,
  isEditing,
  onEdit,
}) => {
  const [expanded, setExpanded] = useState<Record<string, boolean>>({
    embedded: true,
    extended: true,
    custom: true,
  });

  const toggle = (key: string) => setExpanded((prev) => ({ ...prev, [key]: !prev[key] }));

  return (
    <Card sx={{ mb: 0, boxShadow: 'none' }}>
      <CardContent sx={{ borderRadius: '10px', boxShadow: 'none', p: 0 }}>
        <Box sx={{ p: 2 }}>
          <Typography sx={{ fontWeight: 600, fontSize: '18px' }}>Enablement Model</Typography>
        </Box>

        {SECTION_CONFIG.map((section) => (
          <EnablementSection
            key={section.key}
            sectionKey={section.key}
            label={section.label}
            iconSrc={section.iconSrc}
            agents={(normalizedAgentData[section.key] as CardData[]) || []}
            bgcolor={section.bgcolor}
            skeletonBgcolor={section.skeletonBgcolor}
            skeletonCount={section.skeletonCount}
            isLoading={isLoading}
            isExpanded={expanded[section.key]}
            isEditing={isEditing}
            onToggle={() => toggle(section.key)}
            onEdit={onEdit}
          />
        ))}
      </CardContent>
    </Card>
  );
};

export default AiEnablementView;
